import FeaturesServiceAna from '../_raw/features/icon_features_service_ana.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesServiceAna, { shouldSetDefaultSize: false });
